import { render, staticRenderFns } from "./ExtratoFornecedorModule.vue?vue&type=template&id=4ec111e3"
import script from "./ExtratoFornecedorModule.vue?vue&type=script&lang=js"
export * from "./ExtratoFornecedorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports